import { defineMessages } from "react-intl";

const messages = defineMessages({
  featuresOk: {
    id: "settings.emailPreferences.disconnectedEmail.disconnectedEmail.InfoModal.ok",
    defaultMessage: "Okay",
    description: "Email Feature modal ok",
  },
  featuresPoint1Description: {
    id: "email.emailFeatureModal.point1Description",
    defaultMessage:
      "In order to protect accounts from being spammed, you have a daily sending limit of 700 emails per day and 100 emails per hour.",
    description: "Email Feature modal point 1 description",
  },
  featuresPoint1Title: {
    id: "email.emailFeatureModal.point1Title",
    defaultMessage: "Sending Limits",
    description: "Email Feature modal point 1 title",
  },
  featuresPoint2Description: {
    id: "email.emailFeatureModalPoint2Description",
    defaultMessage:
      "Activities will be logged when each email is sent. Everything entered in the previous form, except for the email content, will be included in each activity. You can edit activities after they're created. {br} These email activities can’t be marked “not done” or have their time changed because they are logged once an email is successfully sent.",
    description: "Email Feature modal point 2 description",
  },
  featuresPoint2Title: {
    id: "email.emailFeatureModalPoint2Title",
    defaultMessage: "Automatically logged email activities",
    description: "Email Feature modal point 2 title",
  },
  featuresPoint3Description: {
    id: "email.emailFeatureModalPoint3Description",
    defaultMessage:
      "Every email sent through MMC will track the number of opens and clicks on links and attachments inside the email. Tracking preferences can be managed in settings.",
    description: "Email Feature modal point 3 description",
  },
  featuresPoint3Title: {
    id: "email.emailFeatureModalPoint3Title",
    defaultMessage: "Email tracking",
    description: "Email Feature modal point 3 title",
  },
  featuresPoint4Description2: {
    id: "email.emailFeatureModalPoint4Description2.outbox",
    defaultMessage:
      "Emails that cannot be sent immediately are held in your Email Outbox. This happens when it's outside your sending hours or your daily send limit has been reached. You can view, manage, and cancel pending emails from the Outbox at any time.",
    description: "Email Feature modal point 4 description - part 2",
  },
  featuresPoint4Title: {
    id: "email.emailFeatureModalPoint4Title.outbox",
    defaultMessage: "Email Outbox",
    description: "Email Feature modal point 4 title",
  },
  featuresTitle: {
    id: "email.emailFeatureModalTitle",
    defaultMessage: "About MMC Emails",
    description: "Email Feature modal title",
  },
  openEmailOutbox: {
    id: "email.emailFeatureModal.openOutbox",
    defaultMessage: "Open Email Outbox",
    description: "Email Feature modal open email outbox",
  },
});

export default messages;
